import { firestoreAction } from 'vuexfire'
import { db } from '@/config/firebase'

const schedules = {
  namespaced: true,
  state: {
    schedules: []
  },
  actions: {
    bindRef: firestoreAction(context => {
      return context.bindFirestoreRef(
        'schedules',
        db
          .collection('schedules')
          .where('owner', '==', context.rootGetters['users/getActiveUserId'])
      )
    })
  },
  getters: {
    getSchedules: state => state.schedules
  },
  modules: {
    events: {
      namespaced: true,
      state: {
        events: []
      },
      actions: {
        bindRef: firestoreAction((context, id) => {
          return context.bindFirestoreRef(
            'events',
            db
              .collection('schedules')
              .doc(id)
              .collection('events')
          )
        })
      },
      getters: {
        getScheduleEvents: state => state.events
      }
    }
  }
}

export default schedules
